// Injected at build time by vite.config.ts (SPA_CLIENT_ID, ENTRA_TENANT_ID).
const clientId = (import.meta.env.SPA_CLIENT_ID as string | undefined)?.trim() ?? '';
const tenantId = (import.meta.env.ENTRA_TENANT_ID as string | undefined)?.trim() ?? '';

/** Delegated Graph scopes; see docs/APP-REGISTRATION.md section 4. */
export const sharePointConfig = {
  clientId,
  authority: tenantId ? `https://login.microsoftonline.com/${tenantId}` : '',
  scopes: ['Sites.Read.All', 'Files.ReadWrite.All'],
  // A dedicated page: MSAL blocks the redirect page from running the app in the popup.
  redirectPath: '/msal-redirect.html'
};

/** The feature stays hidden until the SPA registration is configured. */
export const isSharePointConfigured = clientId !== '' && tenantId !== '';
